<div class="modal-content">
  <div class="header">
    <mat-icon
      (click)="changeTitleTask = !changeTitleTask"
      class="iconEditTitle"
      >{{ !changeTitleTask ? "edit" : "delete_outline" }}</mat-icon
    >
    <p class="titleModal">
      {{ task.editedTitle ? task.editedTitle : task.title }}
    </p>

    <mat-icon class="closeModal" [mat-dialog-close]>cancel</mat-icon>
  </div>
  <div class="container" style="padding: 0 2rem">
    <div class="information row">
      <div class="col-6">
        <p>
          <b>Fecha de Creación:</b>
          {{ task.createdAt | date : "d/MM/yyyy h:mm a" }}
        </p>
        <p>
          <b>Modificado por:</b>
          {{ task.updateBy?.fullname || "Sin modificar" }}
        </p>
        <p>
          <b>Estado del caso:</b>
          {{ stateCase }}
        </p>
      </div>
      <div class="col-6">
        <p>
          <b>Última Modificación:</b>
          {{ task.updatedAt | date : "d/MM/yyyy h:mm a" }}
        </p>
        <p *ngIf="task.description">
          <b>Descripción: </b> {{ task.description }}
        </p>
      </div>
      <div class="col-12">
        <div *ngIf="changeTitleTask">
          <mat-form-field style="width: 80%" appearance="outline">
            <mat-label>Nuevo título</mat-label>
            <input
              [(ngModel)]="titleTaskChange"
              type="text"
              matInput
              placeholder="Nuevo título tarea"
            />
          </mat-form-field>
          <mat-icon class="iconOkEdit" (click)="saveNewTitle()"
            >check_circle_outline</mat-icon
          >
        </div>
      </div>
    </div>

    <div class="content-component" *ngIf="ComponentValue">
      <ng-template appComponentValue></ng-template>
    </div>

    <form
      [formGroup]="form"
      class="style-form-default"
      style="padding: 0"
      *ngIf="task.requiresObservations || task.requiresFiles"
    >
      <div
        class="style-input-default column-complete"
        *ngIf="task.requiresObservations; else elseObservaciones"
      >
        <p style="color: rgb(255, 143, 143)" *ngIf="!canUpdate">
          * Mínimo 20 caracteres
        </p>
        <textarea
          rows="6"
          placeholder="Observaciones..."
          formControlName="observations"
        ></textarea>
      </div>
      <ng-template #elseObservaciones>
        <div *ngIf="task.requiresObservations" class="column-complete">
          <h4 style="border-bottom: 1px solid #ccc; margin: 0">
            Observaciones
          </h4>
          <p class="observaciones_value" style="white-space: break-spaces">
            {{ task.observations ? task.observations : "Sin Observaciones..." }}
          </p>
        </div>
      </ng-template>
      <div *ngIf="showAdjuntos" class="column-complete">
        <button
          class="btn-file"
          (click)="case?.status != 'archived' ? addFile() : ''"
          *ngIf="task.requiresFiles"
        >
          Subir archivo adjunto
        </button>
        <table class="table mt-2 mb-2" *ngIf="task.requiresFiles">
          <thead>
            <tr>
              <th scope="col"></th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let file of files">
              <td style="text-align: left">{{ file.name }}</td>
              <td style="text-align: right">
                <button class="btn-save" (click)="view(file)">
                  <mat-icon>visibility</mat-icon>
                </button>
                <button class="btn-save ml-2" (click)="downloadFile(file)">
                  <mat-icon>save</mat-icon>
                </button>
                <button
                  class="btn-delete ml-2"
                  (click)="
                    case.status != 'archived' ? deleteFile(file._id) : ''
                  "
                  *ngIf="task.requiresFiles && canEdit"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </form>
    <div class="loading" *ngIf="loading">
      <mat-spinner diameter="25"></mat-spinner>
    </div>
    <div class="text-center mt-4" style="margin-bottom: 10px">
      <button
        class="cancel-btn rounded"
        mat-raised-button
        *ngIf="
          !task.required && canDelete && !loading && case?.status != 'archived'
        "
        (click)="deleteTask()"
      >
        Eliminar Tarea
      </button>

      <button
        class="primary-btn rounded ml-3"
        mat-raised-button
        *ngIf="canEdit && !loading && case?.status != 'archived'"
        (click)="guardar()"
        [disabled]="!form.valid"
      >
        {{ textoGuardar }}
      </button>
    </div>
  </div>
</div>
